import React from 'react'
import { observer } from 'mobx-react'
import cx from 'classnames'
import './styles.sass'

const ImageChoicesChallengeView = ({ challenge }) => (
  <div className="image-choices-challenge">
    <div className="images">
      {challenge.choices.map((image) =>
        <ImageChoice
          key={image.source}
          source={image.source}
          selected={image === challenge.selectedChoice}
          onClick={() => challenge.setAnswer(image)}
        />
      )}
    </div>
  </div>
)

const ImageChoice = ({ selected, source, onClick }) => (
  <div className="image-choice">
    <button
      className={cx('image-button', selected && 'is-selected')}
      aria-checked={selected}
      aria-role="checkbox"
      onClick={onClick}
      type="button"
    >
      <img src={source} alt="Image" />
    </button>
  </div>
)

export default observer(ImageChoicesChallengeView)



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/ImageChoicesChallenge/View.jsx